var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.5.7@core-js/modules/_cof.js
// module id = 98
// module chunks = 0